import { create } from "zustand";
export const useSoldSNStore = create((set) => ({
  letters: null,
  companies: null,
  snList: null,
  foundSNList: null,
  setFoundSNList: (foundSNList) => set({ foundSNList }),
  setLetters: (letters) => set({ letters }),
  setCompanies: (companies) => set({ companies }),
  setSNList: (snList) => set({ snList }),
}));
